import { useTranslation } from 'react-i18next';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function HowItWorksSection() {
  const { t } = useTranslation();
  
  const steps = [
    {
      step: '1',
      titleKey: 'howItWorks.step1.title',
      descKey: 'howItWorks.step1.desc',
      color: 'bg-blue-600'
    },
    {
      step: '2',
      titleKey: 'howItWorks.step2.title',
      descKey: 'howItWorks.step2.desc',
      color: 'bg-purple-600'
    },
    {
      step: '3',
      titleKey: 'howItWorks.step3.title',
      descKey: 'howItWorks.step3.desc',
      color: 'bg-green-600'
    }
  ];

  const scrollToTradingWidget = () => {
    const tradingSection = document.querySelector('#trading-widget');
    if (tradingSection) {
      tradingSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <section className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {t('howItWorks.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {steps.map((step, index) => (
            <Card key={index} className="text-center relative">
              <div className={`w-16 h-16 ${step.color} rounded-full flex items-center justify-center mx-auto mb-6`}>
                <span className="text-2xl font-bold text-white">{step.step}</span>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4">{t(step.titleKey)}</h3>
              <p className="text-gray-400 leading-relaxed">{t(step.descKey)}</p>
              
              {/* Connection line for desktop */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 -right-4 w-8 h-0.5 bg-gray-600"></div>
              )}
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Button size="lg" className="text-lg px-8 py-4" onClick={scrollToTradingWidget}>
            <i className="ri-shopping-cart-line mr-2"></i>
            {t('howItWorks.cta')}
          </Button>
        </div>
      </div>
    </section>
  );
}
